import { useFetch } from '../../hooks';
import { getAgentPresets } from '../../api';

export const usePresets = (id: string) => {
  return useFetch(() => getAgentPresets(id), [id]);
};

export type { PresetType } from '../../api';
